// extracted by mini-css-extract-plugin
export var active = "_bi-2";
export var highlight = "_bi-1";
export var highlightLayer = "_bi-0";
export var issuePopover = "_bi-3";
export var statusIcon = "_bi-4";